



































































































































































































































































import Vue from 'vue';
import { Component, Model } from 'vue-property-decorator';
import { Base } from '@/components/common/base';
import { PaginationModel, VAction, VHeaders } from '@/models/pagedlistmodel';
import { callHistoryService, conversationService, userService } from '@/shared';
import { DateTimeHelper as _dateTime } from '@/helper/date-time.helper';
import { mask } from 'vue-the-mask';
import { Utils } from '@/helper/utils';
import { mapGetters } from 'vuex';
import { NotificationType } from '@/helper/enum';

@Component({
  props: ['methodName', 'progress'],
  directives: {
    mask,
  },

  components: {
    Grid: () => import('@/components/common/app.grid.vue'),
    Calendar: () => import('@/components/common/app.calendar.vue'),
  },
})
export default class CallHistoryListPage extends Base {
  public panel: any = [0];
  public pagination = new PaginationModel('createdAt');
  public phoneMask: string = '(###)###-#####';
  public loading: boolean = false;
  public customerInfoLoader: boolean = false;
  public actions: VAction[] = [];
  public currentTime: number = 0;

  public headers: VHeaders[] = [
    {
      align: 'left',
      sortable: true,
      text: this.$parent.$t('callHistory.dateTime') as string,
      value: `createdAt`,
      fieldType: 'date',
    },
    {
      align: 'left',
      sortable: true,
      text: 'Store',
      value: 'storeName',
    },
    {
      align: 'left',
      sortable: true,
      text: this.$parent.$t('callHistory.callerName') as string,
      value: 'callerName',
    },
    {
      align: 'left',
      sortable: true,
      text: this.$parent.$t('callHistory.direction') as string,
      value: 'direction',
    },
    {
      align: 'left',
      sortable: true,
      text: this.$parent.$t('callHistory.duration') as string,
      value: `duration`,
      fieldType: 'template',
      template: (model) => {
        const d = Number(model.duration);
        const h = Math.floor(d / 3600);
        const m = Math.floor((d % 3600) / 60);
        const s = Math.floor((d % 3600) % 60);

        const hDisplay = h > 0 ? h + (h == 1 ? ' hour ' : ' hour ') : '';
        const mDisplay = m > 0 ? m + (m == 1 ? ' min ' : ' min ') : '';
        const sDisplay = s > 0 ? s + (s == 1 ? ' sec' : ' sec') : '';

        return `<span> ${hDisplay + mDisplay + sDisplay} </span>`;
      },
    },
    {
      align: 'left',
      sortable: true,
      text: this.$parent.$t('callHistory.status') as string,
      value: 'status',
    },
    {
      align: 'left',
      sortable: true,
      text: 'From Number',
      value: 'fromNumber',
    },
    {
      align: 'left',
      sortable: true,
      text: 'To Number',
      value: 'toNumber',
    },
    {
      align: 'center',
      isNotDataProp: true,
      text: 'Action',
      sortable: false,
    },
  ];
  public searchByNumber: string = '';
  public showSendEmailPopup: boolean = false;
  public emailLoader = false;
  public resetFilter: boolean = false;
  public showTextPopup: boolean = false;
  public searchOnDms: boolean = false;
  public playRecording: boolean = false;
  public isInvalidEmail = false;
  public callRecord: any[] = [];
  public userStores: any[] = [];
  public customerDetails = {};
  public src: string = '';
  public numbers: any[] = ['From Number', 'To Number'];
  public selectedNumber: string = 'From Number';
  public textToNumber: string = '';
  public selectedStore: string = '';
  public selectedStoreId: number = 0;

  public customerInfoFromNumber: string = '';
  public customerInfoToNumber: string = '';
  public flags: any = {
    showStartDatePicker: false,
    showEndDatePicker: false,
  };

  public params: any = {
    startDate: '',
    endDate: '',
  };

  public recordingSid: string = '';
  public customerEmail: string = '';
  public comment: string = '';
  public recordingFromNumber: string = '';
  public recordingToNumber: string = '';
  public recordingDate: string = '';

  public maxToDate: any = _dateTime.addDays(new Date(), 30);
  // public todayDate: any = _dateTime.currentDate(new Date());

  public mounted() {
    // activating tab
    this.$root.$emit('sidebar.layout.vue', 'callHistory');

    this.setActions();
    this.getUserStores();
  }

  public created(): void {
    this.params.startDate = this.getMonthStartDate();
    this.params.endDate = this.presentDate();
  }

  public formateCurrentDate(date) {
    let month = (date.getMonth() + 1).toString();
    if (Number(month) < 10) {
      month = '0' + month;
    }
    let day = (date.getDate() + 1).toString();

    if (Number(day) < 10) {
      day = '0' + day;
    }
    const d = `${date.getFullYear()}-${month}-${day}`;
    return d;
  }

  public setInvoiceDateParmsGlAccount(dates: any) {
    if (dates.length > 0) {
      if (dates[0]) {
        this.params.startDate = dates[0];
      } else {
        this.params.startDate = '';
      }
      if (dates[1]) {
        this.params.endDate = dates[1];
      } else {
        this.params.endDate = '';
      }
    }
  }

  public formatDate(date) {
    if (!date) {
      return null;
    }
    const [year, month, day] = date.split('-');
    return `${month}/${day}/${year}`;
  }

  public validateEmail(email) {
    // tslint:disable-next-line:max-line-length
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    this.isInvalidEmail = re.test(String(email).toLowerCase());
    return this.isInvalidEmail;
  }

  public setActions(): void {
    this.actions = [
      {
        type: 'button',
        icon: 'fa fa-play-circle',
        title: 'Play Recording',
        action: (model: any) => {
          this.getCallRecordingDetails(model.recordingSid);
        },
        visible: (model) => {
          if (model.recordingSid) {
            return true;
          } else { return false; }
        },
      },
      {
        type: 'button',
        icon: 'far fa-user-circle',
        title: 'Customer Info',
        action: (model: any) => {
          if (model.storeId) {
            this.selectedStore = model.storeName;
            this.selectedStoreId = model.storeId;
          }
          this.getCustomerDeatils(model.toNumber, model.fromNumber);
        },
      },
      {
        type: 'button',
        icon: 'fa fa-envelope',
        title: 'Send Recording On Email',
        action: (model: any) => {
          this.sendRecording(
            model.recordingSid,
            model.fromNumber,
            model.toNumber,
            model.createdAt,
            true
          );
        },
        visible: (model) => {
          if (model.recording) {
            return true;
          } else {
            return false;
          }
        },
      },
      {
        type: 'button',
        icon: 'fa fa-paper-plane',
        title: 'Send Recording On Text',
        action: (model: any) => {
          this.sendRecording(
            model.recording,
            model.fromNumber,
            model.toNumber,
            model.createdAt,
            false
          );
        },
        visible: (model) => {
          if (model.recording) {
            return true;
          } else {
            return false;
          }
        },
      },
    ];
  }

  public async getCallHistory(): Promise<void> {
    var fromNumber = '';
    var toNumber = '';
    if (this.searchByNumber == '') {
        this.showNotification(NotificationType.Warning, "Please Select from or to number & add number");
      return;
    }
    try {
      this.loading = true;
      this.$emit('update:progress', this.loading);
      if (this.selectedNumber == 'From Number') {
        fromNumber = this.searchByNumber;
      }
      if (this.selectedNumber == 'To Number') {
        toNumber = this.searchByNumber;
      }
      const response = await callHistoryService.getCallHistory(
        this.pagination,
        fromNumber,
        toNumber,
        this.params.startDate,
        this.params.endDate
      );

      this.callRecord = response.results;
      this.pagination.totalItems = response.total;
      fromNumber = '';
      toNumber = '';
    } finally {
      this.loading = false;
      this.$emit('update:progress', this.loading);
    }
  }

  public async getUserStores() {
    const response = await userService.GetUserDetailsByUserId(
      this.userSession.sessionUserId
    );
    this.userStores = response.userStores;
    if (this.userStores != null) {
      const data = this.userStores.filter(
        (x) => x.storeId == this.userSession.storeId
      )[0];
      this.selectedStore = data.storeName;
      this.selectedStoreId = data.storeId;
    }
  }

  public getCustomerDeatilsById(event) {
    const data = this.userStores.filter((x) => x.storeName == event)[0];
    this.selectedStoreId = data.storeId;
    this.selectedStore = data.storeName;
    this.getCustomerDeatils(
      this.customerInfoToNumber,
      this.customerInfoFromNumber
    );
  }

  public closeSearchOnDms() {
    this.searchOnDms = false;
    this.customerDetails = {};
    this.customerInfoFromNumber = '';
    this.customerInfoToNumber = '';
  }

  public async getCustomerDeatils(toNumber: string, fromNumber: string) {
    try {
      let customerNumber = '';
      this.customerInfoFromNumber = fromNumber;
      this.customerInfoToNumber = toNumber;
      if (this.selectedNumber == 'To Number') {
        if (toNumber != '') {
          if (toNumber.includes('sip')) {
            customerNumber = toNumber.substring(4, 16);
          } else {
            customerNumber = toNumber;
          }
        }
      }

      if (this.selectedNumber == 'From Number') {
        if (fromNumber != '') {
          if (fromNumber.includes('sip')) {
            customerNumber = fromNumber.substring(5, 16);
          } else {
            customerNumber = fromNumber;
          }
        }
      }

      this.searchOnDms = true;
      this.customerInfoLoader = true;

      const response = await callHistoryService.getCallCustomerDeatils(
        customerNumber,
        this.selectedStoreId
      );
      this.customerDetails = response;
      customerNumber = '';
    } finally {
      this.customerInfoLoader = false;
    }
  }

  public async getCallRecordingDetails(recordingId) {
    const uri =
      Utils.API_BASE_URL + '/messages/getCallRecording/' + recordingId;
    //  var response = await conversationService.GetCallRecordingUrl(recordingId);
    this.src = uri;
    // this.src = response;
    this.playRecording = true;
  }

  public stopRecording() {
    this.src = '';
    this.playRecording = false;
    this.currentTime = 0;
    this.$refs.audio['currentTime'] = 0;
  }

  public sendRecording(
    recordingSid: string,
    fromNumber: string,
    toNumber: string,
    recordingDate: string,
    isEmail: boolean
  ) {
    if (isEmail == true) {
      this.recordingSid = recordingSid;
      this.recordingFromNumber = fromNumber;
      this.recordingToNumber = toNumber;
      this.recordingDate = recordingDate;
      this.showSendEmailPopup = true;
    }
    if (isEmail == false) {
      this.recordingSid = recordingSid;
      this.recordingFromNumber = fromNumber;
      this.recordingToNumber = toNumber;
      this.recordingDate = recordingDate;
      this.showTextPopup = true;
    }
  }

  public closeSendEmailPopup() {
    this.showSendEmailPopup = false;
    this.customerEmail = '';
    this.comment = '';
  }

  public resetFilters() {
    this.params.endDate = '';
    this.params.startDate = '';
    this.resetFilter = !this.resetFilter;
  }

  public closeTextPopup() {
    this.showTextPopup = false;
    this.textToNumber = '';
    this.comment = '';
  }

  public async sendRecordingEmail(isEmail) {
    if (isEmail == true) {
      if (this.customerEmail == '') {
        this.showAlert(false, 'Please add Email');
        return;
      }
      if (!this.isInvalidEmail) {
        this.showAlert(false, 'Invalid Email');
        return;
      }

      try {
        this.emailLoader = true;
        const response = await callHistoryService.sendRecordingEmail(
          this.recordingSid,
          this.customerEmail,
          this.comment,
          this.recordingFromNumber,
          this.recordingToNumber,
          '',
          this.recordingDate,
          isEmail
        );
        this.showAlert(true, 'Email Sent successfully');
      } finally {
        this.showSendEmailPopup = false;
        this.emailLoader = false;
        this.customerEmail = '';
        this.comment = '';
      }
    }
    if (!isEmail) {
      if (this.textToNumber == '') {
        this.showAlert(false, 'Please enter number');
        return;
      }
      try {
        this.emailLoader = true;
        const response = await callHistoryService.sendRecordingEmail(
          this.recordingSid,
          this.customerEmail,
          this.comment,
          this.recordingFromNumber,
          this.recordingToNumber,
          this.textToNumber,
          this.recordingDate,
          isEmail
        );
        this.showAlert(true, 'Text Sent successfully');
      } finally {
        this.showTextPopup = false;
        this.emailLoader = false;
        this.customerEmail = '';
        this.comment = '';
      }
    }
  }

  public updatePaging(paging: PaginationModel): void {
    this.pagination = paging;
    this.getCallHistory();
  }

  public search(): void {
    if (this.params.startDate == '') {
      this.showAlert(false, 'Please select start date');
      return;
    }
    if (this.params.endDate == '') {
      this.showAlert(false, 'Please select end date');
      return;
    }
    this.pagination.page = 1;
    this.getCallHistory();
  }

  public SkipForwardRecording(event) {
    var audio = this.$refs.audio['currentTime'];
    this.currentTime = audio + 6;
  }

  public SkipBackwardRecording() {
    var audio = this.$refs.audio['currentTime'];
    this.currentTime = audio - 6;
  }
}
